import './setPublicPath'
import Vue from 'vue'
import wrap from '@vue/web-component-wrapper'

// runtime shared by every component chunk
import '/opt/build/repo/node_modules/css-loader/dist/runtime/api.js'
import '/opt/build/repo/node_modules/vue-style-loader/lib/addStylesShadow.js'
import '/opt/build/repo/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js'

window.customElements.define('api-expert-collection-table', wrap(Vue, () => import('~root/src/standalone/CollectionTable.vue?shadow')))

window.customElements.define('api-expert-covid19', wrap(Vue, () => import('~root/src/standalone/Covid19.vue?shadow')))

window.customElements.define('api-expert-crypto-currency-exchanges', wrap(Vue, () => import('~root/src/standalone/CryptoCurrencyExchanges.vue?shadow')))

window.customElements.define('api-expert-enterprise-it', wrap(Vue, () => import('~root/src/standalone/EnterpriseIt.vue?shadow')))

window.customElements.define('api-expert-enterprise-messaging', wrap(Vue, () => import('~root/src/standalone/EnterpriseMessaging.vue?shadow')))

window.customElements.define('api-expert-fintech', wrap(Vue, () => import('~root/src/standalone/Fintech.vue?shadow')))

window.customElements.define('api-expert-full-page', wrap(Vue, () => import('~root/src/standalone/FullPage.vue?shadow')))

window.customElements.define('api-expert-government-uk', wrap(Vue, () => import('~root/src/standalone/GovernmentUk.vue?shadow')))

window.customElements.define('api-expert-government-us', wrap(Vue, () => import('~root/src/standalone/GovernmentUs.vue?shadow')))

window.customElements.define('api-expert-i-p-geolocators', wrap(Vue, () => import('~root/src/standalone/IPGeolocators.vue?shadow')))

window.customElements.define('api-expert-messaging-cpaas-solutions', wrap(Vue, () => import('~root/src/standalone/MessagingCpaasSolutions.vue?shadow')))

window.customElements.define('api-expert-open-banking-psd2-sandboxes', wrap(Vue, () => import('~root/src/standalone/OpenBankingPsd2Sandboxes.vue?shadow')))

window.customElements.define('api-expert-open-banking-uk', wrap(Vue, () => import('~root/src/standalone/OpenBankingUk.vue?shadow')))

window.customElements.define('api-expert-open-banking-uk-open-data', wrap(Vue, () => import('~root/src/standalone/OpenBankingUkOpenData.vue?shadow')))

window.customElements.define('api-expert-open-banking-uk-production', wrap(Vue, () => import('~root/src/standalone/OpenBankingUkProduction.vue?shadow')))

window.customElements.define('api-expert-provider-table', wrap(Vue, () => import('~root/src/standalone/ProviderTable.vue?shadow')))

window.customElements.define('api-expert-search', wrap(Vue, () => import('~root/src/standalone/Search.vue?shadow')))

window.customElements.define('api-expert-social-networks', wrap(Vue, () => import('~root/src/standalone/SocialNetworks.vue?shadow')))

window.customElements.define('api-expert-weather', wrap(Vue, () => import('~root/src/standalone/Weather.vue?shadow')))